import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelCase } from '../types/label-case.type';

export const UpdateLabelCaseValidationSchema = z.object({
  labelCaseId: z.string({ message: 'Label ID is required' }).min(1),
  name: z.string().min(1).optional(),
  color: z.string().min(1).optional(),
});
export type TUpdateLabelCaseValidation = z.infer<typeof UpdateLabelCaseValidationSchema>;
export type TUpdateLabelCasePayload = TUpdateLabelCaseValidation;
export type TUpdateLabelCaseResponse = ApiResponse<TLabelCase>;

export const updateLabelCase = async (payload: TUpdateLabelCasePayload): Promise<TUpdateLabelCaseResponse> => {
  const url = `/label-case/${payload.labelCaseId}`;

  const payloadData = {
    name: payload?.name,
    color: payload?.color,
  };

  return axiosInstance.patch(url, payloadData);
};

type TUseUpdateLabelCaseMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof updateLabelCase, AxiosErrorCustom>;
};

export const useUpdateLabelCaseMutation = ({ mutationConfigOptions }: TUseUpdateLabelCaseMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: updateLabelCase,
    ...restConfigOptions,
  });
};
